module.exports = __webpack_public_path__ + "desktop-web.jpg?49396362d67aa006834cca4912fd5e10";